<template>
  <div style="overflow-y:scroll;height:100%">
    <Headermenu></Headermenu>
    <div class="content">
      <div v-if="isSearch"
           class="search">
        <div class="search-box">
          <a-input v-model:value="searchValue"
                   enter-button="Search"
                   size="large"
                   class="search-input" />
          <a class="search-btn"
             @click="onSearch">{{ $t('home.CmsSector.search') }}</a>
        </div>
      </div>
      <Breadcrumb v-else
                  :tag="tag || sectorName"></Breadcrumb>
      <div v-for="item in sectorList"
           :key="item.id"
           class="wrap"
           @click="detailArticle([item])">
        <a-image :width="200"
                 :height="130"
                 class="coverImg"
                 :preview="false"
                 :src="toUrl(item.image)" />
        <div class="txt">
          <h2>{{ item.title }}</h2>
          <p>{{ getSimpleText(item.content) }}</p>
          <div class="tagList">
            <span v-for="(tagLabel, index) in item.tag"
                  :key="index"
                  class="tagClass">{{ tagLabel }}</span>
          </div>
        </div>
      </div>
      <a-pagination v-model:pageSize="limit"
                    v-model:current="current"
                    :total="paginationTotal"
                    show-less-items
                    style="text-align:center;margin-bottom:20px;"
                    @change="changePagination" />
    </div>
  </div>
  <component :is="'iota-default-customer'"></component>
</template>

<script setup lang="ts">
import { getSimpleText, toUrl } from '@/utils'
import { onMounted, ref, watch } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { getSectorSearch } from '../api/index'
import type { searchType, sectorType } from '../api/interface/sectorinterface'
import { useHomeStore } from '../index'
import Breadcrumb from './components/Breadcrumb.vue'
import Headermenu from './components/HeaderMenu.vue'

const router = useRouter()
const route = useRoute()
const storeState = useHomeStore()
const sectorList = ref<sectorType['contents']>([])
const paginationTotal = ref(0)
const current = ref<number>(1)
const offset = ref<number>(0)
const limit = ref<number>(5)
const tag = ref<string>('')
const isSearch = ref<boolean>(false)
const sector_id = ref()
const sectorName = ref()
onMounted(() => {
  init()
})
const init = async () => {
  tag.value = route.query.tag as string
  sectorName.value = route.query.sectorName
  sector_id.value = route.params.id
  const isSector = !!route.query.sectorName
  if (route.query.label && route.query.label == 'search') {
    isSearch.value = true
    searchValue.value = route.query.value as string
    await onSearch()
  } else {
    await getSectorList(tag.value, isSector)
  }
}

const getSectorList = async (keywords: string, isSector?: boolean) => {
  const data: searchType = {
    keywords,
    limit: 5,
    offset: offset.value
  }
  isSector ? delete data.keywords : ''
  route.path !== '/posts/search' ? data.sector_id = sector_id.value : delete data.sector_id
  const list = await getSectorSearch(data) as any
  sectorList.value = list.rows
  paginationTotal.value = list.total
}

const detailArticle = (contentItem: sectorType['contents']) => {
  storeState.cmsContentItem = {
    ...contentItem[0],
    currentPage: current.value
  }
  router.push(`/posts/content/${contentItem[0].id}`)
}
const searchValue = ref<string>('')
const onSearch = async () => {
  getSectorList(searchValue.value)
}
const changePagination = async (page: number, pageSize: number) => {
  offset.value = (page - 1) * pageSize
  getSectorList(searchValue.value)
}
watch(
  () => route.query, () => {
    init()
  }
)
</script>

<style scoped lang="less">
* {
  box-sizing: border-box;
}

.content {
  width: 600px;
  margin: 50px auto;

  .search {
    // width: calc(100vw - 500px);
    margin-bottom: 50px;

    .search-box {
      width: 550px;
      height: 50px;
      background-color: #002FA7;
      border-radius: 3px;
      position: relative;


      .search-input {
        width: 445px;
        height: 40px;
        margin: 5px;
        background: #fff;
        border: 1px solid #fff;
        border-radius: 3px;
        display: inline-block;
      }

      .search-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 100px;
        height: 50px;
        text-align: center;
        font-size: 18px;
        color: #fff;
        line-height: 50px;
        cursor: pointer;
      }
    }
  }
}

.wrap {
  height: 15%;
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 50px;
}

.wrap img {
  width: 50%;
  vertical-align: middle;
}

:deep(.coverImg) {
  width: 200px;
  height: 110px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
}

.txt {
  width: 50%;
  height: 150px;
  vertical-align: middle;
  padding-left: 20px;
  display: flex;
  flex-wrap: wrap;

  h2 {
    width: 100%;
  }

  p {
    height: fit-content;
    font-size: 13px;
    color: #4a4a4a;
    letter-spacing: 0;
    line-height: 21px;
    width: 100%;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    /* 这里是超出几行省略 */
    overflow: hidden;
  }
}

.tagList {
  align-self: flex-end;
  flex-shrink: 0;

  .tagClass {
    display: inline-block;
    margin-right: 8px;
    margin-bottom: 8px;
    padding: 4px 8px;
    font-size: 12px;
    color: #7e7e7e;
    border: 1px solid #e9e9e9;
    border-radius: 3px;
  }
}
</style>
